global.authorization = new (function () {
    let logged = null;

    this.init = function () {
        logged = Boolean(parseInt(document.querySelector('meta[name="is_user"]').content));

        this.setTimeout();
    };

    this.actionIfChanged = function () {
        window.location.reload();
    };

    this.setTimeout = function () {
        setInterval(() => {
            this.monitoring();
        }, 10000);
    };

    this.monitoring = async function () {
        const newValue = await this.checkAuthorization();

        if (logged !== null && logged !== newValue) {
            logged = newValue;

            this.actionIfChanged();
        }
    };

    this.checkAuthorization = async function () {
        let logged = false;

        await axios.get('/api/users/access/logged/check').then((r) => {
            logged = r.data.data.logged;
        }).catch((e) => {
            if (e.response && e.response.status === 503) {
                window.location.reload();
            }
        });

        return logged;
    }

    this.init();
});
